import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { collapseTextChangeRangesAcrossMultipleVersions } from 'typescript';
import { ApiService } from '../../api/api.service';
import { FormactionService } from '../../api/formaction.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-pduview',
  templateUrl: './pduview.component.html',
  styleUrls: ['./pduview.component.css']
})
export class PduviewComponent implements OnInit {

  public ticketId: any;
  public entrydate: any;
  public state: any;
  public district: any;
  public iticode: any;
  public trade: any;
  public name: any;
  public email: any;
  public mobileno: any;
  public ccrefno: any;
  public ccrefnostatus: any;
  public orderid: any;
  public date: any;
  public singlerollno: any;
  public numberofstud: any;
  public amount: any;
  public descreption: any;
  public admin_status: any;
  public admin_status_desc: any;
  public bulkregno: any;

  public pduStatusForm: any;
  public submitted: any;

  constructor(private formBuilder: FormBuilder, private api: ApiService, private formaction: FormactionService, private router: Router) { }

  ngOnInit(): void {

    this.formaction.get_pduList_single().subscribe((result: any) => {
      var args = {
        ticketId: result.ticketId
      }


      this.api.trackIdPduview(args).subscribe((result: any) => {
        console.log(result)
        this.ticketId = result.ticketId;
        this.entrydate = result.entrydate;
        this.state = result.state;
        this.district = result.district;
        this.iticode = result.iticode;
        this.trade = result.trade;
        this.name = result.name;
        this.email = result.email;
        this.mobileno = result.mobileno;
        this.ccrefno = result.ccrefno;
        this.ccrefnostatus = result.ccrefnostatus;
        this.orderid = result.orderid;
        this.date = result.date;
        this.singlerollno = result.singlerollno;
        this.numberofstud = result.numberofstud;
        this.amount = result.amount;
        this.descreption = result.descreption;
        this.admin_status = result.admin_status;
        this.admin_status_desc = result.admin_status_description;
      })

      // this.api.trackIdPduBulkregno(args).subscribe((result: any) => {
      //   this.bulkregno = result;
      // });

      this.api.trackIdPduBulkregno(args).subscribe((result: any) => {
        console.log(result);
        let bulkreg = '';
        result.forEach((element: any) => {
          bulkreg = bulkreg + element['regno'] + ',';
        });
        this.bulkregno = bulkreg.slice(0, -1);
      });

    });

  }

}
